import { Link } from 'react-router-dom';
import logo from '../assets/logo/i-log-logo-transparent.png';
import { business } from '../data/business';
import './Footer.css';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__brand">
          <img src={logo} alt="i-LOG" className="site-footer__logo" />
          <p className="site-footer__tagline">Capture. Learn. Recommend.</p>
        </div>

        <div className="site-footer__info">
          <p>
            <span>상호</span>
            {business.name}
          </p>
          <p>
            <span>대표</span>
            {business.representative}
          </p>
          <p>
            <span>사업자등록번호</span>
            {business.registrationNumber}
          </p>
          <p>
            <span>사업장 소재지</span>
            {business.address}
          </p>
          <p>
            <span>문의</span>
            <a href={`mailto:${business.email}`}>{business.email}</a>
          </p>
        </div>

        <div className="site-footer__links">
          <Link to="/consent">개인정보 수집 동의</Link>
          <Link to="/privacy">개인정보처리방침</Link>
          <Link to="/terms">이용약관</Link>
        </div>
      </div>
      <div className="site-footer__copy">
        © {new Date().getFullYear()} {business.name}. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;
